// NOT_INCLUDE
export const NOT_INCLUDE = [1, 4, 14, 16]

// 新手任务列表
export const NEWER_TASK = [9]

// 每日任务列表
export const DAY_TASK = [
  37,
  2,
  38,
  18,
  26,
  20,
  21,
  6,
  23,
  25,
  5,
  7,
  22,
  35,
  31,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
]

// 探索任务列表
export const SPECIAL_TASK = [3, 8, 19, 27, 24]

// 其他任务列表
export const VIP_TASK = [36, 28, 29, 30]
